export enum SubscriptionFrequency {
	DAILY = 'DAILY',
	WEEKLY = 'WEEKLY',
	MONTHLY = 'MONTHLY',
	FORTNIGHTLY = 'FORTNIGHTLY',
	QUARTERLY = 'QUARTERLY',
	HALF_YEARLY = 'HALF_YEARLY',
	HALFYEARLY = 'HALFYEARLY',
	ANNUAL = 'ANNUAL',
	YEARLY = 'YEARLY',
	ON_DEMAND = 'ON_DEMAND',
	AS_AND_WHEN_PRESENTED = 'AS_AND_WHEN_PRESENTED',
	BI_MONTHLY = 'BI_MONTHLY',
	BIMONTHLY = 'BIMONTHLY',
	ONE_TIME = 'ONE_TIME',
}

export interface ISubscriptionDetails {
	message: string;
	maxAmount: number;
	frequency: SubscriptionFrequency | string;
	expireAt: number;
	revokable: boolean;
}

export const SubscriptionFrequencyLabels: Record<
	SubscriptionFrequency,
	string
> = {
	[SubscriptionFrequency.DAILY]: 'Daily',
	[SubscriptionFrequency.WEEKLY]: 'Weekly',
	[SubscriptionFrequency.MONTHLY]: 'Monthly',
	[SubscriptionFrequency.FORTNIGHTLY]: 'Fortnightly',
	[SubscriptionFrequency.QUARTERLY]: 'Quarterly',
	[SubscriptionFrequency.HALF_YEARLY]: 'Half Yearly',
	[SubscriptionFrequency.HALFYEARLY]: 'Half Yearly',
	[SubscriptionFrequency.ANNUAL]: 'Annual',
	[SubscriptionFrequency.YEARLY]: 'Yearly',
	[SubscriptionFrequency.ON_DEMAND]: 'On Demand',
	[SubscriptionFrequency.AS_AND_WHEN_PRESENTED]: 'On Demand',
	[SubscriptionFrequency.BI_MONTHLY]: 'Bi-monthly',
	[SubscriptionFrequency.BIMONTHLY]: 'Bimonthly',
	[SubscriptionFrequency.ONE_TIME]: 'One Time',
};
